<template>
  <footer class="footer-wrap bgc-blue">
    <w-footer-link />
    <div class="footer-bottom flex flex-center">
      <div class="c-white">
        <div class="f-16 flex flex-sa">
          <div class="pointer">
            <a class="c-white" target="_blank" href="/file/legal_statement.html"
              >平台法律声明</a
            >
          </div>
          <div class="pointer" @click="$router.push('/beginner/index')">
            新手指南
          </div>
          <div class="pointer" @click="toLogin">机构登录</div>
        </div>
        <div class="f-14 flex flex-sb mt-30">
          <div>主办单位：凤台县市场监督管理局</div>
          <div>&nbsp;&nbsp;&nbsp;&nbsp; 丨 &nbsp;&nbsp;&nbsp;&nbsp;</div>
          <div>技术支持： 安徽标信查数据技术有限公司</div>
        </div>
        <div class="f-14 text-center mt-10">
          ICP备案编号：皖ICP备2022010709号-2
        </div>
        <div class="f-14 text-center mt-10">
          建议使用：1920*1080分辨率/谷歌浏览器访问达到最佳效果
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import { removeData } from "@/utils/auth";
import WFooterLink from "@/views/layout/components/WFooterLink";
export default {
  components: {
    WFooterLink,
  },
  computed: {
    ...mapGetters(["userType"]),
  },
  methods: {
    toLogin() {
      if (this.userType) {
        this.$alert("此操作将退出当前账号！", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
          showCancelButton: true,
        })
          .then(() => {
            removeData();
            this.$router.push("/login?type=1");
          })
          .catch(() => {});
      } else {
        this.$router.push("/login?type=1");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-content-wrap {
  background: #0194f6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  font-size: 14px;

  ul {
    display: flex;
    justify-content: center;
    color: #ffffff;

    li {
      span {
        margin: 0 10px;
      }
    }
  }

  a {
    font-size: 14px !important;
    color: #ffffff;
  }

  .footer-screen {
    font-size: 12px;
    color: #ffffff;
  }
}

.w-800 {
  width: 800px;
}

.footer-bottom {
  padding: 35px 0 24px;
  box-sizing: border-box;
}
</style>
